import { createAction } from '@reduxjs/toolkit';
export const changeMeta = createAction('SET_METADATA', (title, description, keywords) => ({
    payload: {
        title,
        description,
        keywords,
    },
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWN0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBb0MsWUFBWSxFQUFFLE1BQU0sa0JBQWtCLENBQUM7QUFHbEYsTUFBTSxDQUFDLE1BQU0sVUFBVSxHQUN0QixZQUFZLENBQUMsY0FBYyxFQUFFLENBQUMsS0FBYSxFQUFFLFdBQW1CLEVBQUUsUUFBaUIsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUN4RixPQUFPLEVBQUU7UUFDUixLQUFLO1FBQ0wsV0FBVztRQUNYLFFBQVE7S0FDUjtDQUNELENBQUMsQ0FBQyxDQUFDIn0=